import React, { useState, useEffect } from 'react';
import './GeocodeSettings.scss';

const GeocodeSettings = () => {
  const [apiKey, setApiKey] = useState('');
  const [isSaved, setIsSaved] = useState(false);
  const [hasStoredKey, setHasStoredKey] = useState(false);

  useEffect(() => {
    const savedKey = localStorage.getItem('google_geocode_key');
    if (savedKey) {
      setApiKey(savedKey);
      setHasStoredKey(true);
    } else if (process.env.REACT_APP_GEOCODE_KEY) {
      setHasStoredKey(true);
    }
  }, []);

  const handleSave = () => {
    if (apiKey.trim()) {
      localStorage.setItem('google_geocode_key', apiKey);
      setHasStoredKey(true);
      setIsSaved(true);
      setTimeout(() => setIsSaved(false), 2000);
    }
  };

  const handleClear = () => {
    localStorage.removeItem('google_geocode_key');
    setApiKey('');
    setHasStoredKey(!!process.env.REACT_APP_GEOCODE_KEY);
  };

  return (
    <div className="GeocodeSettings">
      <div className="settings-header">
        <div className="title-row">
          <h3>Geocoding API Key</h3>
          {hasStoredKey && <span className="status-badge">Active</span>}
        </div>
        <p>Only required if any lat/lng fields are blank in your files</p>
      </div>
      <div className="settings-content">
        <input
          type="password"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="Enter Google API Key"
        />
        <div className="button-group">
          <button className="save-button" onClick={handleSave}>
            {isSaved ? 'Saved!' : 'Save'}
          </button>
          <button className="clear-button" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeocodeSettings;
